export default __webpack_public_path__ + "static/media/pto_on_icon.66d23444.svg";